import { CustomerFile } from 'types/customer-files';

export const buildGoogleMapsURL = (customerFile: CustomerFile): string => {
  return `https://www.google.com/maps/place/${customerFile.street_number}+${customerFile.street}+${customerFile.postal_code}+${customerFile.city}/`;
};
